<template>
  <div class="detail-container">
    <Header />
    <div class="artcle-detail">
      <div class="container">
        <!-- <one v-if="id == 1" />
        <two v-else-if="id == 2" />
        <three v-else-if="id == 3" /> -->
        <div class="left-detail">
          <div class="page">
            使用教程 >
            <span @click="$router.push('/course-page')" class="tap"
              >使用必读</span
            >
            > <span>{{ detail.title }}</span>
          </div>
          <!-- <div class="title">{{detail.title}}</div> -->
          <div v-html="detail.content"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getItem, removeItem } from '@/utils/storage.js'
import { getTutorialDetail } from '@/api/course.js'
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import { createTutorialDetail } from './courseList/create.js'
// import One from './components/one.vue'
// import Two from './components/two.vue'
// import Three from './components/three.vue'

const selectText = (ele) => {
  if (document.body.createTextRange) {
    let range = document.body.createTextRange()
    range.moveToElementText(ele)
    range.select()
    range = null
  } else if (window.getSelection) {
    let selection = window.getSelection()
    let range = document.createRange()
    range.selectNodeContents(ele)
    selection.removeAllRanges()
    selection.addRange(range)
    range = null
    selection = null
  }
}

export default {
  name: 'courseDetail',
  components: {
    Header,
    // One,
    // Two,
    // Three,
    Footer
  },
  props: {},
  data() {
    return {
      id: '',
      detail: {},
      videoData: {
        a: 1,
        clientData: null,
        clientHeight: 0,
        DOMobj: null
      },
      winScroll: null,
    }
  },
  computed: {},
  watch: {},
  created() {
    this.id = this.$route.query.id
    this.getTutorialDetail()
  },
  mounted() {
    const { id } = this.$route.query
    if (!id) {
      this.$router.replace('/course-page')
    }
  },
  methods: {
    goToAppoint() {
      setTimeout(() => {
        this.$nextTick(() => {
          const { id } = this
          const askId = getItem('askId')
          removeItem('askId')
          let askDomeId = `#course_${id}_${askId}`
          if (id == 5) {
            askDomeId = `#h${askId}`
          }
          const element = document.querySelector(askDomeId)
          // console.log('element', element)
          if (element) {
            window.scrollTo({
              top: element.offsetTop, // 滚动距离
              behavior: 'smooth'
            })
            selectText(element)
            // 因为视频的初始高度需要 等待才能出来
            if (document.querySelector('video')) {
              setTimeout(() => {
                window.scrollTo({
                  top: element.offsetTop, // 滚动距离
                  behavior: 'smooth'
                })
              }, 600)
            }
          }
        })
      })
    },
    async getTutorialDetail() {
      this.detail = createTutorialDetail(this.id)
      /* 每次都要后端进行更改数据太麻烦了 
        直接前端自己根据json生成算了 
        以后改动也不需要再次让后端去更改库里的数据了
        后续稳定有时间再和后端重新约定格式
      */
      this.$nextTick(() => {
        this.init()
      })
      const type = getItem('type')
      removeItem('type')
      console.log('type', type)

      this.goToAppoint()
    },
    async getTutorialDetail_old() {
      let res = await getTutorialDetail(this.id)
      if (res.success) {
        this.detail = res.data
        this.$nextTick(() => {
          this.init()
        })
        const type = getItem('type')
        removeItem('type')
        console.log('type', type)

        this.goToAppoint()

        if (type) {
          setTimeout(() => {
            this.$nextTick(() => {
              if (this.id != 5) {
                window.scrollTo({
                  top: document.querySelectorAll('h3')[type].offsetTop, // 滚动距离
                  behavior: 'smooth'
                })
                // document.querySelectorAll('h3')[type].children[0].style.color = 'blue'
                // document.querySelectorAll('h3')[type].children[0].className = 'blue'
              } else {
                window.scrollTo({
                  top: document.querySelector('#h' + type).offsetTop, // 滚动距离
                  behavior: 'smooth'
                })
                // document.querySelector('#h' + type).children[0].style.color = 'blue'
                // document.querySelector('#h' + type).children[0].className = 'blue'
              }
            })
          }, 200)
        }
        this.$nextTick(() => {
          if (type || type === 0) {
            let element = document.querySelectorAll('h3')[type]
            element && selectText(element)
          }
        })
      }
    },
    init() {
      let _this = this
      _this.videoData.clientData = getViewport() // 获取可视区的大小
      getDMOlocation()
      if(!_this.videoData.DOMobj) {
        return
      }
      _this.videoData.a = 1
      this.winScroll = winScroll
      window.addEventListener('scroll', this.winScroll);
      function winScroll() {
        if(!_this.videoData.DOMobj) {
          _this.videoData.a -= 1
          getDMOlocation()
          return
        }
        let arr = getElementViewTop(_this.videoData.DOMobj)
        let viedos = document.getElementById(`video-${_this.videoData.a}`)
        if (arr <= _this.videoData.cliHeight && -arr <= _this.videoData.DOMobj.offsetHeight / 2) {
          viedos.play()
        } else {
          viedos.pause()
          if (-arr > _this.videoData.DOMobj.offsetHeight / 2) {
            _this.videoData.a += 1
          } else if (-arr < 0) {
            if (_this.videoData.a === 1) {
              return
            } else {
              _this.videoData.a -= 1
            }
          }
          getDMOlocation()
        }
      }
      function getViewport() {
        if (document.compatMode == "BackCompat") {
          return {
            width: document.body.clientWidth,
            height: document.body.clientHeight
          }
        } else {
          return {
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
          }
        }
      }
      function getDMOlocation() { // 获取元素的相关数据
        _this.videoData.DOMobj = document.getElementById(`arr${_this.videoData.a}`)
        console.log(_this.videoData.DOMobj )
        if(_this.videoData.DOMobj) {
            _this.videoData.cliHeight = (_this.videoData.clientData.height - _this.videoData.DOMobj.offsetHeight) / 2
        }
      }
      function getElementViewTop(element) {
        var actualTop = element.offsetTop;
        var current = element.offsetParent;

        while (current !== null) {
          actualTop += current.offsetTop;
          current = current.offsetParent;
        }
        let elementScrollTop

        if (document.compatMode == "BackCompat") {
          elementScrollTop = document.body.scrollTop;
        } else {
          elementScrollTop = document.documentElement.scrollTop;
        }

        return actualTop - elementScrollTop;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.winScroll);
  }
}
</script>

<style scoped lang="scss">
.detail-container {
  position: relative;
  width: 100%;
  padding-top: 120px;
}
.artcle-detail {
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  .container {
    width: 1200px;
  }
}

.left-detail {
  position: relative;
  width: 880px;
  .page {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #24232f;
    margin-bottom: 15px;
    span {
      color: #3c7cff;
    }
    .tap {
      cursor: pointer;
      color: #24232f;
    }
  }
  .title {
    position: relative;
    font-size: 30px;
    font-weight: 600;
    color: #24232f;
    margin-bottom: 12px;
  }
  .blue {
    color: blue !important;
  }
}
</style>